import { useSelector } from "react-redux";
import { getLanguage } from "src/state/features/ui/uiSelector";

export function useLanguageDataGetter<D>(data: any): D {
    const lang = useSelector(getLanguage);
    const langData = data.edges.find((edge: any) => edge && edge.node && edge.node.node_locale === lang);
    return langData ? langData : data.edges[0];
}
